import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row g-xxl-9"
}
const _hoisted_2 = { class: "col-xxl-12" }
const _hoisted_3 = { class: "card card-xxl-stretch mb-5 mb-xxl-10" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "text-gray-800" }, "Допомога з оплати")
  ])
], -1)
const _hoisted_5 = {
  key: 0,
  class: "card-body"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "fs-5 fw-bold text-gray-600 pb-6 d-block" }, " Якщо після оплати у Вас негативний баланс, відправте повідомлення з коротким описом, протягом 10 хв з вами зв'яжеться оператор для вирішення проблеми. ", -1)
const _hoisted_7 = { class: "d-flex align-self-center" }
const _hoisted_8 = { class: "flex-grow-1 me-3" }
const _hoisted_9 = { class: "fv-row mb-10" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Короткий опис (не обов'язково)", -1)
const _hoisted_11 = { class: "fv-plugins-message-container" }
const _hoisted_12 = { class: "fv-help-block" }
const _hoisted_13 = ["disabled", "data-kt-indicator"]
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "bi bi-cash" }),
  /*#__PURE__*/_createTextVNode("Відправити")
], -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Будь ласка, чекайте ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "card mt-10" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "card-header card-header-stretch border-bottom border-gray-200" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Список оплат")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "card-toolbar m-0" }, [
    /*#__PURE__*/_createElementVNode("ul", {
      class: "nav nav-stretch nav-line-tabs border-transparent",
      role: "tablist"
    }, [
      /*#__PURE__*/_createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        /*#__PURE__*/_createElementVNode("a", {
          id: "kt_billing_6months_tab",
          class: "nav-link fs-5 fw-bold me-3 active",
          "data-bs-toggle": "tab",
          role: "tab",
          href: "#kt_billing_months"
        }, "Усі оплати")
      ])
    ])
  ])
], -1)
const _hoisted_19 = { class: "tab-content" }
const _hoisted_20 = {
  id: "kt_billing_months",
  class: "card-body p-0 tab-pane fade show active",
  role: "tabpanel",
  "aria-labelledby": "kt_billing_months"
}
const _hoisted_21 = { class: "table-responsive" }
const _hoisted_22 = { class: "table table-row-bordered table-striped align-middle gy-4 gs-9" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("thead", { class: "border-bottom border-gray-200 fs-6 text-gray-600 fw-bolder bg-light bg-opacity-75" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { class: "min-w-150px" }, "Дата"),
    /*#__PURE__*/_createElementVNode("td", { class: "min-w-250px" }, "Тариф при сплаті"),
    /*#__PURE__*/_createElementVNode("td", { class: "min-w-150px" }, "Сумма"),
    /*#__PURE__*/_createElementVNode("td", { class: "min-w-150px" }, "Баланс до"),
    /*#__PURE__*/_createElementVNode("td", { class: "min-w-150px" }, "Баланс після"),
    /*#__PURE__*/_createElementVNode("td")
  ])
], -1)
const _hoisted_24 = { class: "fw-bold text-gray-600" }
const _hoisted_25 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NoMoneyRequest = _resolveComponent("NoMoneyRequest")!
  const _component_ExclamationNotice = _resolveComponent("ExclamationNotice")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!
  const _component_PaymentMethods = _resolveComponent("PaymentMethods")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.userData && _ctx.userData.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(_component_NoMoneyRequest, {
            user_no_money_request: _ctx.userData.user.user_no_money_request
          }, null, 8, ["user_no_money_request"]),
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              (_ctx.userData.user)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_ExclamationNotice, {
                      header: "Телефон",
                      margin: "mt-0 mb-3",
                      padding: "p-3",
                      msg: "Важливо: Ваш телефон має бути вірефікованим. Для верефікації зайдіть в розділ <strong>Налаштування</strong>."
                    }),
                    _hoisted_6,
                    _createVNode(_component_Form, {
                      class: "form w-100",
                      id: "kt_no_money_request_form",
                      "validation-schema": _ctx.no_money_request,
                      onSubmit: _ctx.sendNoMoneyRequest
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _hoisted_10,
                              _createVNode(_component_Field, {
                                class: "form-control form-control-lg form-control-solid",
                                type: "text",
                                name: "short_description",
                                autocomplete: "off"
                              }),
                              _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", _hoisted_12, [
                                  _createVNode(_component_ErrorMessage, { name: "short_description" })
                                ])
                              ])
                            ])
                          ]),
                          _createElementVNode("button", {
                            type: "submit",
                            class: "btn btn-primary px-6 flex-shrink-0 align-self-center",
                            disabled: _ctx.in_progress,
                            "data-kt-indicator": _ctx.in_progress ? 'on' : 'off'
                          }, _hoisted_16, 8, _hoisted_13)
                        ])
                      ]),
                      _: 1
                    }, 8, ["validation-schema", "onSubmit"])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.userData && _ctx.userData.user)
      ? (_openBlock(), _createBlock(_component_PaymentMethods, {
          key: 1,
          "current-user": _ctx.userData
        }, null, 8, ["current-user"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_17, [
      _hoisted_18,
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("table", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("tbody", _hoisted_24, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userData.last_5_payments_list, (payment) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: payment.id
                  }, [
                    _createElementVNode("td", {
                      innerHTML: payment.date_of_payment
                    }, null, 8, _hoisted_25),
                    _createElementVNode("td", null, _toDisplayString(payment.tarif_alias), 1),
                    _createElementVNode("td", null, [
                      _createElementVNode("span", {
                        class: _normalizeClass(["badge", {
                                  'badge-success': payment.amount >= payment.fee,
                                  'badge-warning': payment.amount < payment.fee,
                                }])
                      }, _toDisplayString(payment.amount) + " грн. ", 3)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(payment.cash_before) + " грн.", 1),
                    _createElementVNode("td", null, _toDisplayString(payment.cash_after) + " грн.", 1)
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ], 64))
}